import * as fecha from "fecha";
export const convertShippingDateToReadable = (date) => {
    const formatted = fecha.parse(date, "YYYY-MM-DD");
    return fecha.format(formatted, "dddd, MMMM Do, YYYY");
};
